import { useQuery } from "react-query";
import OrgInfoItem from "./OrgInfoItem";
import styled from "styled-components";
import { SelectedRowAccountInfo } from "api/interfaces/subscription.interface";
import { getSubscriptionDetailAccount } from "api/subscriptionAPI";
import { useCallback, useMemo } from "react";
import useApiError from "hook/useApiError";
import useStompDebouncedRefetch from "hook/useStompDebouncedRefetch";

type Props = {
  selectedRowAccount: SelectedRowAccountInfo;
};

export default function SubscriptionOrgInfo({
  selectedRowAccount,
}: Props): JSX.Element {
  const { data, refetch } = useQuery(
    ["getSubscriptionDetailAccount", selectedRowAccount.accountId],
    () =>
      getSubscriptionDetailAccount({
        accountId: selectedRowAccount.accountId,
      }),
    {
      retry: 0,
      refetchOnWindowFocus: false,
    }
  );

  useStompDebouncedRefetch({
    selector: (state) =>
      ({
        subscriptionActivatedUpdated:
          state.subscriptionStomp.subscriptionActivatedUpdated,
      } as Record<string, unknown>),
    stompKey: ["subscriptionActivatedUpdated"],
    refetch,
  });

  const customer = useMemo(() => {
    if (data?.result && data.result.customer) {
      return data.result.customer;
    }
    return null;
  }, [data]);

  return <Wrapper>{customer && <OrgInfoItem info={customer} />}</Wrapper>;
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  min-width: 0;
  margin-bottom: 16px;
`;
